/** Tiny className joiner for the Cosmos ui library */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
